import { render, staticRenderFns } from "./commonDetails.vue?vue&type=template&id=e060a27a&scoped=true&"
import script from "./commonDetails.vue?vue&type=script&lang=js&"
export * from "./commonDetails.vue?vue&type=script&lang=js&"
import style0 from "./commonDetails.vue?vue&type=style&index=0&id=e060a27a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e060a27a",
  null
  
)

component.options.__file = "commonDetails.vue"
export default component.exports